<template>
    <b-card-group
        :columns="columns"
        :deck="deck"
    >
        <slot />
    </b-card-group>
</template>

<script>
// Components.
import {BCardGroup} from 'bootstrap-vue'

export default {
    components: {BCardGroup},
    props: {
        columns: {type: Boolean},
        deck: {type: Boolean},
    },
}
</script>